/* eslint-disable react/jsx-curly-newline */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useWindowScroll } from '@folklore/hooks';
import { useResizeObserver } from '../../../hooks/useObserver';

import { useModal } from '../../../contexts/ModalsContext';

import * as AppPropTypes from '../../../lib/PropTypes';

import GalaxyIcon from '../../icons/Galaxy';
import stars from '../../../../img/employee/stars_bg.png';

import UrbaniaThinIcon from '../../icons/logos/UrbaniaThin';
import Detector from '../../partials/Detector';
import Button from '../../buttons/Button';
import PlusIcon from '../../icons/Plus';
import Html from '../../partials/Html';

import styles from '../../../../styles/blocks/employee/galaxy.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: AppPropTypes.titlePills,
};

const defaultProps = {
    className: null,
    items: null,
};

const Galaxy = ({ className, items }) => {
    const { setModal } = useModal();
    const { ref: containerRef } = useResizeObserver();
    const { y: scroll = 0 } = useWindowScroll();

    const [paralax, setParalax] = useState(0);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (visible) {
            setParalax(containerRef.current.getBoundingClientRect().y);
        }
    }, [visible, scroll]);

    const openModal = useCallback((title, text, backgroundColor, color) => {
        setModal({
            type: 'timeline',
            title,
            text,
            backgroundColor,
            color,
        });
    }, []);

    const findUrbania = (str) => {
        const hasUrbania = str.toLowerCase().includes('urbania');
        const stripUrbania = str.toLowerCase().replace(/urbania/g, '');

        return { hasUrbania, text: stripUrbania };
    };

    return (
        <div
            ref={containerRef}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={styles.stars}
                style={{
                    transform: `translate(${paralax / 10}px, ${paralax / 20}px)`,
                }}
            >
                <img src={stars} alt="étoiles" className={styles.starsImage} />
            </div>
            <GalaxyIcon className={styles.galaxy} />
            <Detector rootMargin="-10%" onChange={(v) => setVisible(v)}>
                <div className={styles.inner}>
                    {(items || []).map(
                        ({ id = null, titles = [], text = null, color = null, image = null }) => (
                            <div
                                key={`planets-${id}`}
                                className={classNames([
                                    styles.planetContainer,
                                    {
                                        [styles[id]]: id !== null,
                                    },
                                ])}
                            >
                                {(titles || []).map((title, titleI) => {
                                    const { hasUrbania, text: stripText } = findUrbania(title);
                                    const finalTitle = hasUrbania ? stripText : title;
                                    const modalTitle = titles.reduce((t, v) => `${t} | ${v}`);
                                    return (
                                        <Button
                                            key={`planet-${id}-${titleI + 1}`}
                                            onClick={() =>
                                                openModal(
                                                    modalTitle,
                                                    text,
                                                    color,
                                                    id !== 'media' ? '#fff' : '#222',
                                                    id,
                                                )
                                            }
                                            className={classNames([styles.planet], {
                                                [styles.sun]: id === 'media',
                                                [styles.tv]: id === 'tvprod' && titleI === 0,
                                                [styles.prod]: id === 'tvprod' && titleI === 1,
                                                [styles.france]: id === 'magazine' && titleI === 0,
                                            })}
                                            style={{
                                                backgroundColor: color !== null ? color : null,
                                            }}
                                        >
                                            {hasUrbania ? (
                                                <UrbaniaThinIcon
                                                    color={id === 'media' ? '#222' : '#fff'}
                                                    className={styles.urbania}
                                                />
                                            ) : null}
                                            {image !== null ? (
                                                <img
                                                    alt={finalTitle}
                                                    src={image}
                                                    className={styles.planetInnerImage}
                                                />
                                            ) : (
                                                <Html tag="span" body={finalTitle} />
                                            )}
                                            {titleI === titles.length - 1 ? (
                                                <PlusIcon
                                                    color="#fff"
                                                    circleColor="#222"
                                                    className={styles.plus}
                                                />
                                            ) : null}
                                        </Button>
                                    );
                                })}
                            </div>
                        ),
                    )}
                </div>
            </Detector>
        </div>
    );
};

Galaxy.defaultProps = defaultProps;
Galaxy.propTypes = propTypes;

export default Galaxy;
